import { LogLevel } from '@amplitude/analytics-types';
import { objectKeysDiff } from './utils';
import { getAutomaticGlobalProperties } from './windowPropertiesHelper';
let automaticGlobalProperties = false;
let globalProperties = {};
let globalPropertiesCallback;
let requiredPropertiesCallback;
const name = 'globalProperties';
const type = 'enrichment';
let debug = false;
const setup = async function (config) {
  /* istanbul ignore next */
  debug = config.logLevel === LogLevel.Debug;
};
const execute = async function (event) {
  var _globalPropertiesCall, _requiredPropertiesCa;
  const original = event.event_properties ?? {};
  let mapped = {
    ...(automaticGlobalProperties ? getAutomaticGlobalProperties() : {}),
    ...globalProperties,
    ...((_globalPropertiesCall = globalPropertiesCallback) === null || _globalPropertiesCall === void 0 ? void 0 : _globalPropertiesCall()),
    ...((_requiredPropertiesCa = requiredPropertiesCallback) === null || _requiredPropertiesCa === void 0 ? void 0 : _requiredPropertiesCa()),
    ...original
  };
  event.event_properties = mapped;

  /* istanbul ignore next */
  if (debug) {
    const newKeys = objectKeysDiff(mapped, original);
    if (newKeys.length) {
      console.groupCollapsed('Global event properties were added');
      console.log('The following properties were added:');
      const newKeyValues = {};
      newKeys.forEach(key => {
        newKeyValues[key] = mapped[key];
      });
      console.table(newKeyValues);
      console.groupEnd();
    }
  }
  return event;
};
const globalEventPropertiesPluginConstructor = (automaticProperties, globalEventProperties, globalEventPropertiesCallback, requiredEventPropertiesCallback) => {
  automaticGlobalProperties = automaticProperties;
  globalProperties = globalEventProperties;
  globalPropertiesCallback = globalEventPropertiesCallback;
  requiredPropertiesCallback = requiredEventPropertiesCallback;
  const plugin = {
    name,
    type,
    setup,
    execute
  };
  return plugin;
};
export default globalEventPropertiesPluginConstructor;
//# sourceMappingURL=globalEventPropertiesPlugin.js.map